import React from 'react';
import { Creatable } from 'react-select';
import { sortByName } from '../helpers';

class CreatableDropdown extends React.Component {
  componentDidMount() {
    if (this.props.focus) {
      this.selectInput.focus();
    }
  }

  promptTextCreator = label => {
    return this.props.label;
  };

  onTypedNewOptionClick = ({ value }) => {
    this.createNewOption(value);
  };

  onChangeCheckNew = newValue => {
    if (newValue != null) {
      const { value } = newValue;
      if (value === 'dropdown-create-new') {
        this.createNewOption();
      } else {
        this.props.onChange(newValue.value, newValue.label);
      }
    }
  };

  createNewOption = (prefilledValue = '') => {
    const { createNewUrl } = this.props;
    this.value = 'dropdown-create-new';

    /*AR: Commenting out as I dont know what this does and it causes a linting error*/
    //this.props.onClick ? this.props.onClick() : null;
    // this.props.router.push(`${createNewUrl}?name=${prefilledValue}`);
    this.props.router.push(`${createNewUrl}`);
  };

  render() {
    const {
      value,
      focus,
      options,
      onChange,
      keys = ['id', 'name'],
      createNewUrl,
      router,
      label = 'Create New',
      ...rest
    } = this.props;
    const sortedOptions = sortByName(options, keys[1]);
    const formattedOptions = sortedOptions.map(item => ({
      value: item[keys[0]],
      label: item[keys[1]]
    }));
    formattedOptions.push({
      value: 'dropdown-create-new',
      label: label
    });
    return (
      <Creatable
        value={value}
        options={formattedOptions}
        clearable={false}
        placeholder="Please Select"
        aria-label={this.props['aria-label']}
        inputProps={{
          'data-lpignore': 'true',
          ...rest
        }}
        promptTextCreator={this.promptTextCreator}
        onNewOptionClick={this.onTypedNewOptionClick}
        onChange={this.onChangeCheckNew}
        isValidNewOption={() => false}
      />
    );
  }
}

export default CreatableDropdown;



// WEBPACK FOOTER //
// ./src/components/CreatableDropdown.js